export default {
  namespace: 'provisionSteps',

  // Sorting options
  sorting: {},

  // Filter options
  filters: {
    search: {
      label: 'Search'
    }
  }
};
